import type { UseCategory } from '../category/useCategory';
import { EventAssociatedModel, EventRecommendation } from '~/types/adamTypes';

export const useAppEventChapterRecommendation = (
  categoryManager: UseCategory
) => {
  const { category } = categoryManager;

  const { createEvent } = useAppEvent(
    EventAssociatedModel.Recommendation,
    category.value.id,
    category.value.libraryBookId
  );

  const getEventData = () => {
    const eventData: any = {};

    return eventData;
  };

  const showRecommendations = async (
    exerciseWithErrorIds: string[],
    recommendations: { id: string; type: string; recommendationScore: number }[]
  ) => {
    const eventData = getEventData();

    eventData.ExerciseWithErrorIds = exerciseWithErrorIds;
    eventData.Recommendations = recommendations;

    await createEvent(
      EventRecommendation.ChapterRecommendationsShown,
      eventData,
      true
    );
  };

  const openExercisesErrors = async () => {
    const eventData = getEventData();
    await createEvent(
      EventRecommendation.ChapterExerciseWithErrorListOpened,
      eventData
    );
  };

  const startExerciseWithErrors = async (exerciseId: string) => {
    const eventData = getEventData();
    eventData.ExerciseId = exerciseId;
    await createEvent(
      EventRecommendation.ChapterExerciseWithErrorStarted,
      eventData
    );
  };

  const chapterAdaptiveRecommendationStarted = async (
    recommendationId: string,
    recommendationType: string,
    recommendationPosition: number,
    recommendationScore: number
  ) => {
    const eventData = getEventData();
    eventData.RecommendationId = recommendationId;
    eventData.RecommendationType = recommendationType;
    eventData.RecommendationPosition = recommendationPosition;
    eventData.RecommendationScore = recommendationScore;
    await createEvent(
      EventRecommendation.ChapterAdaptiveRecommendationStarted,
      eventData
    );
  };

  return {
    showRecommendations,
    openExercisesErrors,
    startExerciseWithErrors,
    chapterAdaptiveRecommendationStarted,
  };
};
